var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMatrixRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.938 2.5C22.075 2.5 23 3.412 23 4.536v14.928c0 1.124-.924 2.036-2.063 2.036H3.063C1.925 21.5 1 20.588 1 19.464V4.536C1 3.412 1.924 2.5 3.063 2.5zM6.078 15.733h-3.36v3.562c0 .28.233.509.516.509H7.76v-2.235a7.043 7.043 0 01-1.682-1.836zm3.4 2.799v1.272h5.04v-1.27c-.782.3-1.63.466-2.518.466-.89 0-1.74-.166-2.523-.468zm11.803-2.8h-3.358a7.06 7.06 0 01-1.681 1.837l-.001 2.235h5.04v-4.072zM5.301 9.964H2.719v4.072H5.3C5.105 13.392 5 12.708 5 12s.105-1.392.3-2.036zm15.98 0H18.7c.196.644.301 1.328.301 2.036s-.105 1.392-.3 2.036h2.581V9.964zM7.76 4.196H3.234a.515.515 0 00-.515.51v3.562h3.358a7.06 7.06 0 011.681-1.837l.001-2.235zm13.522 0h-5.04v2.235a7.043 7.043 0 011.682 1.836h3.358v-4.07zm-6.763 0h-5.04v1.272A6.975 6.975 0 0112 5c.887 0 1.736.165 2.518.466v-1.27zM12 17a5 5 0 10-.001-10.001A5 5 0 0012 17zm0-1.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  }))));
}

export default SvgMatrixRadio;